import { Injectable } from "@angular/core";
import { ResourceFactMappingPattern } from "@app/models/rest/resource-fact-mapping-pattern";
import {
  HateoasResourceOperation,
  ResourceCollection
} from "@lagoshny/ngx-hateoas-client";

@Injectable({
  providedIn: "root"
})
export class ResourceFactMappingPatternRestService extends HateoasResourceOperation<ResourceFactMappingPattern> {
  constructor() {
    super(ResourceFactMappingPattern);
  }
}
